export default __webpack_public_path__ + "static/media/enochian.f58dabba.woff2";